export default "__VITE_ASSET__DeKGJhpb__"